<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
};
</script>

<style>
@import url('./assets/css/base.css');
@import url('./assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/App.vue